// i18n area 'common' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/common.sr-Latn-RS.meta.json.
import type { enUS } from './common'

export const srLatnRS: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Virtuelne mašine',
    templates: 'Šabloni',
    importVms: 'Uvezi VM',
    containers: 'Kontejneri',
    containersApps: 'Aplikacije',
    containersPods: 'Podovi',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI slike',
    containersOciRegistries: 'OCI registryji',
    containersCtTemplates: 'CT šabloni',
    networkServices: 'Mrežni servisi',
    firewall: 'Firewall',
    checkpoints: 'Checkpointi',
    backup: 'Rezervne kopije',
    monitoring: 'Nadgledanje',
    cluster: 'Klaster',
    clusterSettings: 'Globalna podešavanja',
    clusterNodes: 'Čvorovi',
    clusterDevices: 'USB i PCIe resursi',
    clusterFederation: 'Federacija',
    network: 'Mreža',
    overlayNetworks: 'Overlay mreže',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Podaci',
    storages: 'Storage',
    hci: 'Hiperkonvergencija',
    ceph: 'Ceph',
    system: 'Sistem',
    tasks: 'Zadaci',
    events: 'Događaji',
    audit: 'Audit',
    diagnostics: 'Dijagnostika',
    notifications: 'Obaveštenja',
    proximity: 'TVirt Proximity',
    users: 'Korisnici i grupe',
    groups: 'Grupe',
    mfa: 'MFA',
    realms: 'Realmovi i SSO',
    rbac: 'Uloge i dozvole',
    credentials: 'Akreditivi',
    scopes: 'Scope',
    tags: 'Tagovi',
    explorer: 'Istraži',
    licensing: 'Licenca',
    information: 'Informacije'
  },
  mode: {
    light: 'Svetla',
    dark: 'Tamna',
    system: 'Sistemska',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Jezik'
  },
  langRegion: {
    europe: 'Evropa',
    northAmerica: 'Severna Amerika',
    southAmerica: 'Južna Amerika',
    asia: 'Azija'
  },
  notFound: {
    title: 'Stranica nije pronađena',
    body: 'Ova adresa ne odgovara nijednoj TVirt stranici — možda se pomerila sa nekim ažuriranjem, ili je link zastareo.',
    backHome: 'Nazad na Home'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Ceo klaster',
    noChildren: 'Ovde nema pod-scopeova',
    recursive: 'Uključi potomke',
    collapse: 'Skupi panel scopeova',
    openPicker: 'Istraži scopeove',
    up: 'Jedan nivo naviše',
    countTooltip: '{direct} u ovom scopeu · {total} sa potomcima'
  },
  search: {
    tooltip: 'Pretraži (⌘K)',
    placeholder: 'Pretraži VM-ove, mreže, storage…',
    empty: 'Nema rezultata',

    // Round command palette (#221, ratifica 2026-08-06): intestazioni dei
    // gruppi, i tipi fuori dal censimento explorer, il vocabolario tasti e i
    // verbi del gruppo Azioni.
    groups: {
      recent: 'Nedavno',
      shortcuts: 'Prečice',
      actions: 'Akcije',
      goTo: 'Idi na'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Čvor'
    },
    footer: {
      navigate: 'kretanje',
      open: 'otvori',
      close: 'zatvara'
    },
    actions: {
      createVm: 'Kreiraj VM…',
      uploadIso: 'Otpremi ISO…',
      clusterSettings: 'Podešavanja klastera',
      consoleOf: 'Idi na konzolu za {name}'
    }
  },
  stub: {
    containersSummary: 'Aplikacije i sistemski kontejneri (CT), sa svojim OCI slikama, registryjima i šablonima — upravljani uz vaše VM-ove.',
    sectionSummary_vms: 'Virtuelne mašine i njihovi šabloni — životni ciklus, snimci, migracija i konzole.',
    sectionSummary_storages: 'Storage na kojima žive diskovi, slike i metapodaci VM-ova.',
    sectionSummary_catalogs: 'Dom datotečnih artefakata klastera: ISO slike, CT i VM šabloni i OCI arhive, organizovani u kataloge.',
    sectionSummary_overlay: 'VXLAN overlay mreže između čvorova klastera.',
    sectionSummary_fabric: 'Inventar fizičke mreže — switchevi, portovi, LAGG-ovi i logičke mreže.',
    sectionSummary_ipam: 'Adresiranje izvedeno iz fabric i overlay mreža: ko drži svaku adresu.',
    sectionSummary_services: 'DHCP i DNS serveri izvedeni iz mrežnog registra.',
    sectionSummary_ceph: 'Upravljani Ceph klasteri na TVirt čvorovima.',
    sectionSummary_hci: 'Hiperkonvergentne storage tehnologije na TVirt čvorovima.',
    sectionSummary_cluster: 'Čvorovi, članstvo i podešavanja na nivou klastera.',
    containers: 'Sistemski kontejneri su na roadmapu — ova sekcija će ih udomiti.',
    containersApps: 'Kontejnerizovane aplikacije su na roadmapu — ova oblast će ih udomiti.',
    containersPods: 'Podovi grupišu kontejnere koji dele mrežu i volumene — instance su aplikacije.',
    containersCt: 'Sistemski kontejneri (CT) su na roadmapu — ova oblast će ih udomiti.',
    multiscsi: 'TVStor MultiSCSI je na roadmapu — ova oblast će ga udomiti.',
    clusterFederation: 'Federacija između TVirt klastera je na roadmapu — ova oblast će je udomiti.',
    containersOciImages: 'OCI slike su na roadmapu — ova oblast će ih udomiti.',
    containersOciRegistries: 'OCI registryji su na roadmapu — ova oblast će ih udomiti.',
    containersCtTemplates: 'CT šabloni su na roadmapu — ova oblast će ih udomiti.',
    importVms: 'Ovde će stići ESXi i Proxmox importeri: konverzija guestova i masovna migracija u TVirt.',
    backup: 'Integrisane rezervne kopije stižu sa 6.2: deduplikovani content-addressed repozitorijumi, CBT inkrementali, prozori nepromenljivosti i repo-to-repo replikacija.',
    monitoring: 'Dashboardi nadmetanja za resurse na nivou celog klastera (cpu.ready, PSI pritisak, ugrađeni alerti) su na putu — danas iste metrike žive u detaljima svake VM.'
  },
  home: {
    welcome: 'Prijavljeni ste kao: {name}',
    subtitle: 'Evo vašeg TVirt klastera na prvi pogled.',
    loadError: 'Pregled nije moguće učitati — da li je TVirt backend dostupan?',
    health: {
      ok: 'Sve je u redu',
      warning: 'Potrebna pažnja',
      critical: 'Kritični problemi'
    },
    reason: {
      'node-down': '{subject} je ugašen',
      'node-stale': '{subject} se ne javlja već neko vreme',
      'node-maintenance': '{subject} u održavanju',
      'tasks-failed': {
        one: '{n} neuspešan zadatak u poslednja 24h',
        few: '{n} neuspešna zadatka u poslednja 24h',
        other: '{n} neuspešnih zadataka u poslednja 24h'
      },
      'storage-degraded': 'storage {subject} degradiran',
      'storage-error': 'storage {subject} u stanju greške',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store klastera nedostupan',
      'license-absent': 'nema licence — novi VM-ovi ne mogu da se pokrenu',
      'license-expired': 'licenca istekla — novi VM-ovi ne mogu da se pokrenu',
      'license-exceeded': 'limit licence prekoračen — novi VM-ovi ne mogu da se pokrenu',
      'failover-reserve-eroded': 'failover rezerva skoro potrošena',
      'failover-reserve-exhausted': 'failover rezerva iscrpljena — novi VM-ovi ne mogu da se pokrenu',

      'oci-cache-nearly-full': 'OCI keš skoro pun na {subject} — digesti se izbacuju ručno',
      'oci-cache-full': 'OCI keš pun na {subject} — nijedan pull neće uspeti dok se digesti ne izbace',
      'config-replica-empty': 'replika konfiguracije na {subject} je PRAZNA — čvor nema konfiguraciju klastera dok replikacija ne uspe',
      'config-replica-stalled': 'replikacija konfiguracije na {subject} stoji — lokalna kopija zaostaje za konfiguracijom klastera'
    },
    staleChip: 'Podaci nisu ažurni',
    staleAsOf: 'poslednja replika {time}',
    zone: {
      nodes: 'Čvorovi',
      failoverReserve: 'Failover rezerva',
      capacity: 'Kapacitet',
      workload: 'Radno opterećenje',
      protection: 'Zaštita',
      activity: 'Nedavna aktivnost'
    },

    // La zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Rezerva netaknuta',
        eroded: 'Rezerva skoro potrošena',
        exhausted: 'Rezerva iscrpljena',
        unknown: 'Rezerva nepoznata'
      },
      tolerate: {
        one: 'toleriše gubitak {n} čvora',
        few: 'toleriše gubitak {n} čvora',
        other: 'toleriše gubitak {n} čvorova'
      },
      usedOf: '{used} / {allowed} GiB u upotrebi',
      keepFree: '{n} GiB se drži slobodno za failover',
      expendable: 'od čega se {n} može žrtvovati u radu',
      headroom: 'može se pokrenuti još {n} GiB',
      short: 'rezervi nedostaje {n} GiB — novi VM-ovi ne mogu da se pokrenu',

      // Pagine enormi per taglia (ratifica 2026-08-04) — forma «etichetta:
      // {n}» apposta: nessuna lingua deve declinare dopo un numero variabile.
      hp: {
        usedOf: 'Stranice od {size} — u upotrebi: {used} / {allowed}',
        keepFree: 'drže se slobodne za failover: {keep}',
        headroom: 'još se mogu pokrenuti: {n}',
        short: 'nedostaje rezervi: {n} — novi VM-ovi sa ogromnim stranicama ne mogu da se pokrenu'
      },
      worstCase: 'najgori slučaj: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Nijedan čvor još nije prijavio memoriju — rezerva se ne može izračunati i nijedno pokretanje se ne odbija.',
      reason: {
        attestedDown: 'atestiran kao ugašen',
        maintenance: 'u održavanju',
        unreachable: 'nedostupan',
        capacityUnknown: 'memorija nije prijavljena'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} core / {threads} thread',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktivan VM',
        few: '{n} aktivna VM-a',
        other: '{n} aktivnih VM-ova'
      },
      activeVmsUnknown: 'broj aktivnih VM-ova nepoznat',
      lastSeen: 'viđen {time}',
      neverSeen: 'nikad viđen',
      down: 'Ugašen',
      maintenance: 'Održavanje',
      stale: 'Nedostupan'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provizionisano',
      reserve: 'rezerva {n} GiB',
      unobserved: 'kapacitet još nije posmatran',
      empty: 'Još nema storagea'
    },
    workload: {
      vms: 'Virtuelne mašine',
      apps: 'Aplikacije',
      services: 'Mrežni servisi',
      empty: 'Još ništa',
      phasesUnknown: 'raspodela po fazama nije dostupna'
    },
    protection: {
      none: 'Nijedno odredište bekapa nije konfigurisano — zaštitite svoju konfiguraciju.',
      configure: 'Konfiguriši checkpointe',
      noRuns: 'Nijedan checkpoint još nije kreiran.',
      last: 'Poslednji checkpoint',
      onTarget: 'na {target}',
      viewAll: 'Checkpointi'
    },
    activity: {
      empty: 'Nema nedavne aktivnosti',
      failed24: {
        one: '{n} neuspešan u 24h',
        few: '{n} neuspešna u 24h',
        other: '{n} neuspešnih u 24h'
      },
      viewAll: 'Vidi sve zadatke'
    }
  },
  notes: {
    title: 'Beleške',
    tabEdit: 'Izmeni',
    tabPreview: 'Pregled',
    placeholder: 'Slobodne beleške operatera — Markdown se renderuje u pregledu',
    empty: 'Nema beleški',
    tooLarge: 'Beleške premašuju limit od 64 KiB',
    saveError: 'Čuvanje beleški nije uspelo'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Odgovor backenda sadrži vrednost koju ovaj interfejs ne poznaje: {field}={value} — ažurirajte webui na verziju backenda.',
    contractErrorItems: 'Objekti ove liste koje ovaj interfejs ne ume da pročita ({field}={value}) nisu prikazani — ukupno: {count}.',
    staleHint: 'Store nije dostupan — ovo je replika konfiguracije ovog čvora; stanje flote je nepoznato.',
    staleStateAge: 'stanje od {time}',
    staleStateNever: 'stanje nikad nije primljeno iz store-a: vidite samo opažanja ovog čvora',
    staleStateTooltip: 'Store klastera nije dostupan: opaženo stanje (faza, čvor, agent) dolazi iz replike stanja ovog čvora i potiče iz poslednjeg uspešnog čitanja iz store-a — može biti zastarelo.',
    noPermission: 'Nemate dozvolu za ovu radnju',

    // Un budget di attesa scaduto NON è un esito (Luca 2026-08-06): il
    // cronometro del client misura la pazienza del client, non lo stato del
    // server — l'avviso dice «ancora in corso», mai «non riuscita».
    actionStillRunning: 'Akcija je još u toku: ishod još nije poznat',
    staleWrite: 'Neko drugi je izmenio ovaj objekat dok ste ga uređivali — ništa nije upisano. Ponovo učitajte i ponovite izmenu na svežem stanju.',
    staleReload: 'Ponovo učitaj',
    preview: 'Pregled',
    previewTitle: 'Pregled rezultata',
    previewNothingWritten: 'Simulirano na serveru — ništa nije upisano.',
    previewChanged: 'Istaknute su vrednosti koje bi se promenile.'
  },
  context: {
    copySelection: 'Kopiraj izabrani tekst'
  },
  crud: {
    create: 'Kreiraj',
    viewDetails: 'Prikaži detalje',
    viewOrEdit: 'Vidi ili izmeni',
    selected: 'izabrano',
    viewUsingVms: 'Vidi VM-ove koji koriste resurs',
    clearSelection: 'Poništi izbor',
    deleteSelected: 'Obriši izabrano',
    bulkConfirmBody: {
      one: 'Obrisati izabranu stavku ({count})? Ako je zaštićena, biće prijavljena i zadržana.',
      few: 'Obrisati izabrane stavke ({count})? Zaštićene će biti prijavljene i zadržane.',
      other: 'Obrisati izabrane stavke ({count})? Zaštićene će biti prijavljene i zadržane.'
    },
    bulkDeleted: 'obrisano',
    bulkRefused: 'odbijeno',
    fieldId: 'ID',
    createdAt: 'Kreirano',
    updatedAt: 'Ažurirano',
    immutableField: 'Fiksirano pri kreiranju — contract ne dozvoljava izmenu',
    immutableScope: 'Scope se dodeljuje pri kreiranju; neki resursi se premeštaju namenskom radnjom',
    observedField: 'Posmatrano stanje — prijavljuje ga platforma, ne može se menjati'
  }
}
